import { render, staticRenderFns } from "./ItemPortal.vue?vue&type=template&id=251e9624"
import script from "./ItemPortal.vue?vue&type=script&lang=js"
export * from "./ItemPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports